
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { cn } from '@/lib/utils';
import { useToast } from '@/hooks/use-toast';
import { DataExtractionToolProps, ReportData } from './types';
import { downloadPDF, downloadExcel } from './reportGenerators';
import { getSavedReports } from './sampleData';
import ReportsTab from './ReportsTab';
import TemplatesTab from './TemplatesTab';
import ExportTab from './ExportTab';

const DataExtractionTool: React.FC<DataExtractionToolProps> = ({ className }) => {
  const [activeTab, setActiveTab] = useState('reports');
  const { toast } = useToast();

  // Get the sample reports data
  const savedReports = getSavedReports();
  
  // Function to handle download based on file type
  const handleDownload = (report: ReportData) => {
    let message = '';
    
    if (report.fileType === "PDF") {
      message = downloadPDF(report);
    } else if (report.fileType === "Excel" || report.fileType === "CSV") {
      message = downloadExcel(report);
    }
    
    toast({
      title: `${report.fileType} Downloaded`,
      description: message,
    });
  };

  return (
    <div className={cn("p-6 text-gray-800 dark:text-white h-full flex flex-col", className)}>
      <Tabs 
        defaultValue="reports" 
        value={activeTab} 
        onValueChange={setActiveTab} 
        className="w-full flex-1 flex flex-col"
      >
        <TabsList className="grid grid-cols-3 mb-6 bg-gray-100 dark:bg-[#0A1428] w-full max-w-md mx-auto">
          <TabsTrigger value="reports" className="text-sm">Saved Reports</TabsTrigger>
          <TabsTrigger value="templates" className="text-sm">Report Templates</TabsTrigger>
          <TabsTrigger value="export" className="text-sm">Data Export</TabsTrigger>
        </TabsList>
        
        <TabsContent value="reports" className="m-0 pb-4 flex-1 overflow-auto">
          <ReportsTab 
            savedReports={savedReports} 
            handleDownload={handleDownload} 
          />
        </TabsContent>
        
        <TabsContent value="templates" className="m-0 pb-4 flex-1 overflow-auto">
          <TemplatesTab />
        </TabsContent>
        
        <TabsContent value="export" className="m-0 pb-4 flex-1 overflow-auto">
          <ExportTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default DataExtractionTool;
